import type { Delta, Op } from 'quill/core';
import React from 'react';
import { MOD_KEY } from '../../constants/os';
import EmojiAutocompleter from '../../editor/controls/EmojiAutocompleter';
import QuillComponent from '../../editor/QuillComponent';
import type QuillEditor from '../../editor/QuillEditor';
import addTestId from '../../utils/addTestId';
import useEventListener from '../../utils/useEventListener';
import styles from './AnnotationInput.module.scss';

interface AnnotationInputProps {
  quill: QuillEditor | null;
  autoFocus: boolean;
  onChange: (ops: Op[]) => void;
  initialContent: Op[] | Delta;
  onSave: () => void;
}

const AnnotationInput = ({
  quill,
  autoFocus,
  onChange,
  initialContent,
  onSave,
}: AnnotationInputProps) => {
  useEventListener(
    quill?.root,
    'keydown',
    (event) => {
      if (event.key === 'Enter' && event[MOD_KEY]) {
        event.stopPropagation();
        event.preventDefault();
        onSave();
      }
    },
    {},
  );

  return (
    <div {...addTestId('annotation-input')} className={styles.container}>
      <QuillComponent
        noTitleLine
        namespace="annotation"
        contentPlaceholder="Add an annotation"
        moduleConfig={{ table: null, prefixListener: true }}
        initialContent={initialContent}
        readOnly={false}
        onTextChange={() => {
          if (quill && onChange) {
            const actualContent = quill.getContents().ops;
            onChange(actualContent);
          }
        }}
        autoFocus={autoFocus}
      />
      {quill && <EmojiAutocompleter quill={quill} readOnly={false} />}
    </div>
  );
};

export default AnnotationInput;
